import { useWishlistStore } from "~/stores/wishlist";

export default defineNuxtPlugin(() => {
  const wl = useWishlistStore();
  if (!wl.ready) wl.init();
});
